import { UnorderedListOutlined } from '@ant-design/icons';
import { Button, Checkbox, Drawer, message, Radio, Space, Tooltip } from 'antd';
import Title from 'antd/es/typography/Title';
import React, { cloneElement, useCallback, useEffect, useState } from 'react';
import TableAndFilters from './TableAndFilters';

const SelectableListDrawer = ({
  isMultiple,
  columnsData,
  url,
  listChecked,
  porDefecto,
  setNewList,
  setObjectList,
  textButton,
  button,
  title,
  all,
  resetValue,
  placement,
  handleChange,
  fromConfig = true
}) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [checkedList, setCheckedList] = useState([]); // Lista para checkbox
  const [checkedListObject, setCheckedListObject] = useState([]); // Lista para checkbox
  const [value, setValue] = useState(); // Value para radioButton
  const [columns, setColumns] = useState([]);

  const showModal = () => {
    setIsDrawerOpen(true);
  };

  const handleOk = async () => {
    if (value?.id && checkedList.length > 0) {
      if (isMultiple && setNewList) {
        setNewList(checkedList);
      } else if (isMultiple && setObjectList) {
        setObjectList(checkedListObject);
        if (resetValue) {
          setCheckedListObject([]);
          setCheckedList([]);
        }
      } else if (setNewList) {
        if (all) {
          setNewList([value.id]);
        } else {
          setNewList([value]);
        }
      }
      if (resetValue) {
        setValue();
      }

      handleChange(checkedList, value);
      setIsDrawerOpen(false);
    } else if (fromConfig) {
      message.warning('Debe seleccionar al menos un item como opción');
    } else if (!fromConfig && value?.id) {
      handleChange(null, value);
    }
  };

  const handleCancel = () => {
    clearAll();
    setIsDrawerOpen(false);
  };

  const clearAll = () => {
    if (listChecked && listChecked.length > 0) {
      if (isMultiple) {
        setCheckedList(listChecked.map((item) => item.id_subcobertura || item));
        setValue(porDefecto);
      } else {
        setValue(listChecked.find((item) => item.id));
      }
    }
  };

  const onChange = useCallback(
    async (e, record) => {
      const checkedValue = record.id;
      const index = checkedList.indexOf(checkedValue);
      if (index > -1) {
        const newCheckeds = [...checkedList];
        newCheckeds.splice(index, 1);
        setCheckedList(newCheckeds);
        const newCheckedsObjects = [...checkedListObject];
        newCheckedsObjects.splice(index, 1);
        setCheckedListObject(newCheckedsObjects);
        if (value?.id && value?.id === record.id) {
          setValue();
        }
      } else {
        setCheckedList([...checkedList, checkedValue]);
        setCheckedListObject([...checkedListObject, record]);
      }
    },
    [checkedList, checkedListObject, value?.id]
  );

  const onChangeRadio = useCallback(async (e, record) => {
    setValue(record);
  }, []);

  useEffect(() => {
    const columnList = [
      {
        title: '',
        key: 'action',
        dataIndex: ' ',
        width: '10px',
        align: 'center',
        hidden: !fromConfig,
        render: (text, record) => {
          return (
            <Space
              size="small"
              // style={{ textAlign: 'center', display: 'initial' }}
            >
              {isMultiple ? (
                <>
                  <Checkbox
                    key={record.id}
                    checked={!!checkedList.find((item) => item === record.id)}
                    onChange={(e) => onChange(e, record)}
                  />
                </>
              ) : (
                <Radio.Group
                  onChange={(e) => onChangeRadio(e, record)}
                  value={value?.id}
                >
                  <Radio key={record.id} value={record.id} />
                </Radio.Group>
              )}
            </Space>
          );
        }
      },
      {
        title: fromConfig ? 'Por Defecto' : '',
        key: 'action',
        dataIndex: ' ',
        width: '10px',
        align: 'center',
        render: (text, record) => {
          const subcoberturaObj = fromConfig ? record : record.subcobertura;
          return (
            <Space size="small">
              <Radio.Group
                onChange={(e) => onChangeRadio(e, subcoberturaObj)}
                value={value?.id}
              >
                <Radio
                  key={subcoberturaObj.id}
                  value={subcoberturaObj.id}
                  disabled={
                    fromConfig &&
                    !checkedList.find((item) => item === subcoberturaObj.id)
                  }
                />
              </Radio.Group>
            </Space>
          );
        }
      },
      ...columnsData
    ].filter((item) => !item.hidden);

    setColumns(columnList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkedList, value, columnsData, isMultiple, onChange, onChangeRadio]);

  useEffect(() => {
    if (listChecked) {
      setCheckedList(listChecked.map((item) => item.id_subcobertura || item));
    }
    if (porDefecto) {
      setValue(porDefecto);
    }
  }, [listChecked, porDefecto]);

  const ModalButton = () => {
    if (button) {
      const buttonCloned = cloneElement(button, {
        ...button.props,
        onClick: (event) => {
          if (button.props.onClick) {
            button.props.onClick(event);
          }
          showModal();
        }
      });
      return buttonCloned;
    }
    if (textButton) {
      return (
        <Button
          key="2"
          type="dashed"
          shape="round"
          size="small"
          onClick={showModal}
        >
          {textButton}
        </Button>
      );
    }
    return (
      <Tooltip title="Selección de subcoberturas">
        <UnorderedListOutlined
          type="text"
          size="middle"
          onClick={showModal}
          style={{ color: 'rgba(0,0,0,.45)' }}
        />
      </Tooltip>
    );
  };

  return (
    <>
      <ModalButton />
      <Drawer
        title={title}
        placement={placement}
        onClose={handleCancel}
        open={isDrawerOpen}
        style={{
          display: 'block',
          padding: '0 0 0 4%'
        }}
        size="large"
      >
        {columns.length > 0 && (
          <>
            <Title level={5} style={{ textAlign: 'left' }}>
              {fromConfig
                ? `Seleccione las subcoberturas que estarán disponibles para el plan
              configurado`
                : `Seleccione una opción para la Cobertura`}
            </Title>

            <TableAndFilters
              withGeneralFilter
              url={url}
              columns={columns}
              showTable
              hasExportar={false}
              tableLayout="auto"
            />

            <Button key="2" type="primary" size="small" onClick={handleOk}>
              {fromConfig ? `Confirmar` : 'Actualizar'}
            </Button>
          </>
        )}
      </Drawer>
    </>
  );
};

export default SelectableListDrawer;
